import { Component, OnInit, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { Observable } from 'rxjs/Observable';
import { LinkType } from 'app/core/components/workflow-new/common/link-type';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { LicenseService } from 'app/core/services/license.service';

declare var $;

@Component({
  selector: 'itpx-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['../style.css']
})
export class ActionsComponent extends RxComponent implements AfterViewInit {
  @Input() links: LinkType[];
  @Input() platformClass: any;
  @Input() entry: string;
  @Output() expandClicked$ = new EventEmitter<void>();
  @Input() refresh$: Observable<boolean>;
  private linkActions = LinkActions;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private licenseService: LicenseService
  ) { super(); }

  ngAfterViewInit(): void {
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
    }, 10);
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  onLinkClick(link: LinkType) {
    const product = this.platformClass.productVariant.product;
    if (!link.disabled && link.url && 0 < link.url.length) {
      if (product.type === 'Exam' && product.externalAssessment) {
        window.location.href = `/hw/app/courseware/${this.platformClass.id}`;
      } else if (this.entry && this.entry === 'eval') {
        // here link goes somewhere
        this.router.navigate(link.url);
      } else {
        this.router.navigate(link.url, {relativeTo: this.route});
      }
    }
    // else {
    //   this.clicked.emit({ id: link.id });
    // }

  }

  onClickAction(link: LinkType, props: any) {
    if (link.disabled)
      return;
    link.action(props).neverError().bindToLifecycle(this).subscribe();
  }

  onClickRedirect(url: string) {
    return this.router.navigate([url], { relativeTo: this.route });
  }

  onDownload(link: any) {
    if (link.disabled)
      return;
    window.open(link.url, '_blank', 'noopener,noreferrer');
  }

  expandClicked() {
    this.expandClicked$.emit();
  }

  ssoForwardingClicked(link: any) {
    if (link.disabled)
      return;
    this.licenseService.getExternalContentFileUrl(link.id)
      .neverError()
      .bindToLifecycle(this)
      .subscribe(response => window.open(response.data, '_blank'));
  }
}


// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/common/actions/actions.component.ts